<section>
  <div class="header astral-page-header">
    <h1>{{ 'DASHBOARD.MENU.REPORT_REASONABLENESS_CONTROL' | translate }}</h1>
    <div class="astral-page-header__actions">
      <astral-button variant="primary" size="small" type="button" icon="print" labelKey="PRINT_BTN" (click)="onPrintPages()"></astral-button>
      <astral-button variant="primary" size="small" type="button" icon="excel" labelKey="COMMON.EXCEL" (click)="exportExcel()"></astral-button>
    </div>
  </div>

  <app-information-block [text]="'REPORT.HEADER_TOOLTIP.REASONABLENESS_CONTROL' | translate"></app-information-block>

  <form class="filter astral-section-surface astral-form-stack astral-form-stack--relaxed report-filter-surface" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <astral-layout-group [columns]="6" [tabletColumns]="2" [mobileColumns]="1">
      <astral-select [control]="form.controls['company']" [itemsSource]="companies"></astral-select>
      <astral-select [control]="form.controls['property']" [itemsSource]="realEstateProperties"></astral-select>
      <astral-select [control]="form.controls['period1']" [itemsSource]="monthSelection"></astral-select>
      <astral-select [control]="form.controls['period2']" [itemsSource]="monthSelection"></astral-select>
      <app-autocomplete-remote-multi
        [service]="articleGroupService"
        [control]="form.controls['articleGroups']"
      ></app-autocomplete-remote-multi>
    </astral-layout-group>
    <div class="astral-filter-actions">
      <astral-button variant="primary" size="small" type="submit" icon="search" labelKey="SEARCH_BTN"></astral-button>
      @if (dataContext && dataContext.length) {
        <astral-button
          variant="secondary"
          size="small"
          type="button"
          [labelKey]="!expandAllRows ? 'COMMON.EXPAND_ALL' : 'COMMON.COLLAPSE_ALL'"
          (click)="toggleExpandAllRows()"
        ></astral-button>
      }
    </div>
  </form>

  @if (dataContext) {
    <app-expanded-list-view
      [columnDefinitions]="columnDefinitions"
      [itemsSource]="dataContext"
      (rowClick)="onExpandedContentRowClicked($event)"
      [expandAllRows]="expandAllRows"
      [preferencesKey]="'report.reasonableness-control'"
    ></app-expanded-list-view>
  }
</section>
